
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

import { PRODUCTION_ORIGIN } from "@consts";

dayjs.extend(utc);
dayjs.extend(tz);

export default {
	name: "HomeSnippet",
	props: {
		updatedAt: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			reviewData: [
				{
					rating: 4.8,
					reviewCount: "28K",
					storeName: "App Store",
					storeLink: "https://apps.apple.com/us/app/wordfinder-by-yourdictionary/id1436464468",
					reviewText:
						"I like this app. I use WF as a last result to get out of jams so that I will not get frustrated and quit very difficult games. It's easy to use while educating on new words and viewing definitions. Ad-free version helps to keep focus on the game plays!",
				},
				{
					rating: 4.5,
					reviewCount: "6.5K",
					storeName: "Google Play",
					storeLink: "https://play.google.com/store/apps/details?id=com.lovetoknow.wordfinder&hl=en",
					reviewText:
						"For me it is not really a cheat but rather a helper app. I look at it as a word unscrambler with some very handy tips as an extra. WordFinder has increased my points per letter average score from 15 points to 18 points. It has increased my vocabulary and even my articulation and spelling.",
				},
			],
		}
	},
	head() {
		return {
			script: [
				{
					hid: "jsonld-app-googleplay",
					type: "application/ld+json",
					json: {
						"@context": "https://schema.org/",
						"@type": "AggregateRating",
						itemReviewed: {
							"@type": "SoftwareApplication",
							image: `${PRODUCTION_ORIGIN}/static/images/wf-app-icon-android.png`,
							name: "WordFinder for Android",
							applicationSubCategory: "Word",
							applicationCategory: "Game",
							downloadUrl: "https://play.google.com/store/apps/details?id=com.lovetoknow.wordfinder&pcampaignid=web_share",
							operatingSystem: "Android",
							softwareVersion: "7.1.1"
						},
						ratingValue: "4.6",
						ratingCount: 5620
					}
				},
			]
		}
	},
	computed: {
		formattedUpdateDate() {
			return dayjs(this.updatedAt || undefined).format("MM/DD/YYYY");
		}
	},
}
